import React from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { ApiResponse } from "../../../services/api";
import SystemLog from "../../../types/systemLog";

interface SystemLogTableProps {
  rows: SystemLog[];
  columns: GridColDef[];
  apiResponse: ApiResponse<SystemLog> | null;
  paginationModel: any;
  setPaginationModel: any;
}

/**
 * Grid dos logs do sistema. Sem ordenacao por coluna de proposito: e um log, sempre
 * listado do mais recente para o mais antigo (ver SystemLogDAO.FindByFilter).
 */
const SystemLogTable: React.FC<SystemLogTableProps> = ({
  rows,
  columns,
  apiResponse,
  paginationModel,
  setPaginationModel,
}) => {
  return (
    <div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1, minHeight: 0 }}>
        <DataGrid
          rows={rows}
          columns={columns}
          getRowId={(row) => row.id}
          rowHeight={36}
          columnHeaderHeight={40}
          pageSizeOptions={[10, 20, 40, 100]}
          pagination
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          rowCount={apiResponse?.data?.totalItems ?? 0}
          checkboxSelection={false}
          disableRowSelectionOnClick
          getRowClassName={(params) =>
            params.row.nivel === 'ERRO' ? 'system-log-erro' : ''
          }
          sx={{
            '& .MuiDataGrid-row:nth-of-type(even)': {
              backgroundColor: '#f5f5f5',
            },
            '& .MuiDataGrid-row:nth-of-type(odd)': {
              backgroundColor: 'white',
            },
            '& .MuiDataGrid-row:hover': {
              backgroundColor: '#b2d1ff',
            },
            '& .system-log-erro': {
              backgroundColor: '#fdecea !important',
            },
            '& .MuiTablePagination-selectLabel': {
              marginTop: '14px',
            },
            '& .MuiTablePagination-displayedRows': {
              marginTop: '14px',
            },
            '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
              outline: 'none',
            },
            '& .MuiDataGrid-row:focus, & .MuiDataGrid-row:focus-within': {
              outline: 'none',
            },
          }}
        />
      </div>
    </div>
  );
};

export default SystemLogTable;
